import axios from 'axios'
import VUE_APP_API_PONTUS_URL from './getapi/pontus'
// import reset_token from './reset_token'

let apiURL = ''
if (process.env.NODE_ENV === "development") {
  // alert("开发环境");
  // apiURL = 'https://pontus.haiweikexin.com/api/v1'
  apiURL = 'http://proxy.jiankanghao.net:50210/api/v1'
}else {
  // alert("生产环境");
  apiURL = VUE_APP_API_PONTUS_URL
}

let http = axios.create({
  timeout: 12000,
  baseURL: apiURL,
  headers: {'Content-Type': 'application/json'}
});
// // http response 拦截器
// http.interceptors.response.use(
//   response => {
//       if(response.data.status_code == 10000){
//         reset_token()
//         return response;
//     }else{
//         return response;
//     }
//   },
//   error => {
//     return Promise.reject(error.response)   // 返回接口返回的错误信息
//   });

export default http;



// WEBPACK FOOTER //
// ./src/util/pontusApiConfig.js